import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import {
  getFirestore,
  collection,
  getDocs,
  getDoc,
  setDoc,
  updateDoc,
  doc,
  arrayUnion,
} from "firebase/firestore";
import { initializeApp } from "firebase/app";
import MostRecentEntryInDB from "./MostRecentEntryInDB";
const firebaseConfig = {
  apiKey: "AIzaSyDbL2YiSVlHJZr03t7M_xXMZXKxY6hw2bQ",
  authDomain: "mtc-db-firebase.firebaseapp.com",
  projectId: "mtc-db-firebase",
  storageBucket: "mtc-db-firebase.firebasestorage.app",
  messagingSenderId: "340944976821",
  appId: "1:340944976821:web:1d6df1b2a1022ee44c77fc",
  measurementId: "G-4YT5V8LPYS",
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

const quarterOptions = ["WQ", "SQ", "FQ"];
const yearOptions = [
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
];

export default function AddNewWeekToDB() {
  const [latestWeek, setLatestWeek] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [latestQuarterState, setLatestQuarterState] = useState<any | null>(
    null
  );
  useEffect(() => {
    const fetchLatestWeekData = async () => {
      try {
        // Step 1: Get all quarter docs
        const querySnapshot = await getDocs(collection(db, "pickData"));
        const allQuarters: any[] = [];
        querySnapshot.forEach((docSnap) => {
          allQuarters.push({ ...docSnap.data(), docId: docSnap.id });
        });

        // Step 2: Find quarter with highest quarterId
        const latestQuarter = allQuarters.sort(
          (a, b) => b.quarterId - a.quarterId
        )[0];

        if (!latestQuarter || !latestQuarter.docId) return;

        // Step 3: Get full doc (to be safe if it's partial)
        const docRef = doc(db, "pickData", latestQuarter.docId);
        const fullDoc = await getDoc(docRef);
        if (!fullDoc.exists()) return;

        const fullData = fullDoc.data();

        // Step 4: Find week with highest weekId
        const latestWeekData = fullData.weeks.sort(
          (a: any, b: any) => b.weekId - a.weekId
        )[0];
        console.log(latestWeekData.picks);
        setLatestQuarterState(latestQuarter);
        setSelectedQuarterId(latestQuarter.docId); // ✅ This makes the dropdown show latest quarter
        setLatestWeek(latestWeekData);
      } catch (err) {
        console.error("Error fetching latest week:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchLatestWeekData();
  }, []);

  const [status, setStatus] = useState("");
  const [existingQuarters, setExistingQuarters] = useState<any[]>([]);
  const [selectedQuarterId, setSelectedQuarterId] = useState("");
  const [newWeekName, setNewWeekName] = useState("");
  const [newWeekDate, setNewWeekDate] = useState("");
  const [newSpotifyLink, setNewSpotifyLink] = useState("");

  useEffect(() => {
    const fetchQuarters = async () => {
      const querySnapshot = await getDocs(collection(db, "pickData"));
      const all: any = [];
      let maxId = 0;
      querySnapshot.forEach((docSnap) => {
        const data = docSnap.data();
        all.push({ ...data, id: docSnap.id });
        if (typeof data.quarterId === "number" && data.quarterId > maxId) {
          maxId = data.quarterId;
        }
      });
      setExistingQuarters(all);
    };
    fetchQuarters();
  }, []);

  const handleAddWeek = async () => {
    if (!selectedQuarterId || !newWeekName || !newWeekDate) {
      return setStatus("❌ All fields required to add a week.");
    }

    const quarterDoc = doc(db, "pickData", selectedQuarterId);

    try {
      const docSnap = await getDoc(quarterDoc);
      let weeks = [];

      if (docSnap.exists()) {
        const data = docSnap.data();
        weeks = data.weeks || [];
      }

      // Get max weekId, default to 0 if none exist
      const maxWeekId = weeks.reduce(
        (max: any, week: any) => Math.max(max, week.weekId || 0),
        0
      );
      const nextWeekId = maxWeekId + 1;

      const newWeek = {
        weekName: newWeekName,
        weekDate: newWeekDate,
        weekId: nextWeekId,
        spotifyPlaylistLink: newSpotifyLink || "",
        picks: [],
      };
      // Add new week using arrayUnion
      await updateDoc(quarterDoc, {
        weeks: [...weeks, newWeek],
      });

      setStatus(
        `✅ Added ${newWeekName} (Week ${nextWeekId}) to quarter with ID of ${selectedQuarterId}`
      );
      setNewWeekName("");
      setNewWeekDate("");
      setNewSpotifyLink("");
    } catch (err) {
      console.error(err);
      setStatus("❌ Failed to add week.");
    }
  };

  return (
    <>
      <div className="faq">
        <Box>
          <div style={{ textAlign: "center", marginBottom: 10 }}>
            <h1>ADD WEEK TO EXISTING QUARTER</h1>
            <MostRecentEntryInDB comp={"addweek"} />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row", gap: 2, mb: 3 }}>
              <FormControl size="small" sx={{ width: "150px" }}>
                <InputLabel>Quarter</InputLabel>
                <Select
                  value={selectedQuarterId}
                  label="Quarter"
                  onChange={(e: SelectChangeEvent) =>
                    setSelectedQuarterId(e.target.value)
                  }
                >
                  {existingQuarters.map((q) => (
                    <MenuItem key={q.id} value={q.id}>
                      {q.quarterName} (ID: {q.quarterId})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                label="Week Name"
                value={newWeekName}
                onChange={(e) => setNewWeekName(e.target.value)}
                placeholder="e.g., WEEK 1"
                size="small"
                sx={{ width: "150px" }}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "row", gap: 2, mb: 3 }}>
              <TextField
                label="Week Date"
                value={newWeekDate}
                onChange={(e) => setNewWeekDate(e.target.value)}
                placeholder="e.g., (MM/DD/YY) [PARENTHESIS & 2 DIGIT YR]"
                size="small"
                sx={{ width: "390px" }}
              />
              <TextField
                label="Spotify Playlist Link"
                value={newSpotifyLink}
                onChange={(e) => setNewSpotifyLink(e.target.value)}
                size="small"
                sx={{ width: "320px" }}
              />
            </Box>
            <Button
              variant="contained"
              onClick={handleAddWeek}
              sx={{ width: "250px" }}
            >
              Add Week to Quarter
            </Button>
          </div>

          <Typography>{status}</Typography>
          <h4>
            {status.includes(`✅`) && (
              <h4 style={{ color: "red" }}>
                (REFRESH THE PAGE TO ADD THE FIRST PICK TO THE NEW WEEK)
              </h4>
            )}
          </h4>
        </Box>
      </div>
    </>
  );
}
